{
  "es": {
    "timestamp": {
      "labels": {
        "accepted": "Aceptado el {date}",
        "ago": "hace",
        "daysAgo": "{days} día |{days} días",
        "daysRemaining": "Quedan {days} días",
        "deadlineDaysLeft": "Quedan {days} días",
        "deadlineOverdue": "Vencido",
        "due": "Vence el {date}",
        "dueToday": "Vence hoy",
        "dueWas": "Venció el {date}",
        "expired": "Caducado el {date}",
        "hoursAgo": "{hours} hora | {hours} horas",
        "in": "En {time}",
        "justNow": "Ahora mismo",
        "minutesAgo": "{minutes} minuto | {minutes} minutos",
        "monthsAgo": "{months} mes | {months} meses",
        "noDeadline": "Sin fecha límite establecida",
        "overdue": "Retrasado {days} días",
        "sentOn": "Enviado el {date}",
        "sentOnAt": "Enviado el {date} a las {time}",
        "starts": "Empieza el {date}",
        "today": "Hoy",
        "tomorrow": "Mañana",
        "uploaded": "Subido el {date}",
        "weeksAgo": "{weeks} semana | {weeks} semanas",
        "yearsAgo": "{years} año | {years} años",
        "yesterday": "Ayer"
      }
    }
  }
}
